import React from "react";
import moment from "moment";
import { Form } from "antd";
import AddLicenseeForm from "../formSections/AddLicenseeForm";

class AddLicensee extends React.Component {
  render() {
    const {
      next,
      history,
      form,
      name,
      handleFieldsChange,
      handleMediumFormSubmit,
      data
    } = this.props;
    return (
      <AddLicenseeForm
        data={data}
        next={next}
        history={history}
        form={form}
        name={name}
        handleMediumFormSubmit={handleMediumFormSubmit}
        handleFieldsChange={handleFieldsChange}
      />
    );
  }
}

class AddLicenseeData extends React.Component {
  getValueByFieldName(name, val) {
    if (name.includes("Date")) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }

  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    }
    this.props.setForm(this.props.name, this.formRef);
  };

  render() {
    return (
      <FormAddLicensee
        {...this.props}
        data={this.props.data}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
      />
    );
  }
}

const FormAddLicensee = Form.create({
  name: "AddLicensee",
  mapPropsToFields(props) {
    let obj = {};
    props.data &&
      Object.keys(props.data).forEach(name => {
        let err = {};
        if (
          props.createErrors &&
          props.createErrors.data &&
          props.createErrors.data[name]
        ) {
          err.errors = [new Error(props.createErrors.data[name])];
        }
        let all = true;
        if (all) {
          obj[name] = Form.createFormField({
            ...(props.isEditable ? props.data[name] : {}),
            ...(props.isEditable ? err : {}),
            value: props.getValueByFieldName(name, props.data[name])
          });
        }
      });
    return obj;
  }
})(AddLicensee);
export default AddLicenseeData;
